import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
  selector: 'app-march-madness',
  templateUrl: './march-madness.component.html',
  styleUrls: ['./march-madness.component.scss']
})
export class MarchMadnessComponent implements OnInit {
  public login = false;
  public loginSubscription;
  public errorMessage;

  public introText;
  public fbEnabled;
  public googleEnabled;

  public demoOne;
  public demoTwo;
  public demoThree;

  constructor(private auth: AuthService, private router: Router, private af: AngularFireDatabase) {

  }

  ngOnInit() {
    this.loginSubscription = this.auth.isLoggedIn.subscribe((value: boolean) => {
      if(value) {
        console.log("Logged in; redirecting to /home");
        this.router.navigate(['/home']);
        return;
      }
    });

    this.af.object('/static/loginIntro').$ref.once("value").then(about => {
      this.introText = about.val();
    });

    this.af.object('/static/facebookEnabled').$ref.once("value").then(about => {
      this.fbEnabled = about.val();
    });

    this.af.object('/static/googleEnabled').$ref.once("value").then(about => {
      this.googleEnabled = about.val();
    });

    this.af.object('/static/demos/0').$ref.once("value").then(about => {
      this.demoOne = about.val();
    });

    this.af.object('/static/demos/1').$ref.once("value").then(about => {
      this.demoTwo = about.val();
    });

    this.af.object('/static/demos/2').$ref.once("value").then(about => {
      this.demoThree = about.val();
    });
  }

  ngOnDestroy() {
    this.loginSubscription.unsubscribe();
  }

  facebookLogin() {
    this.auth.loginWithFacebook();
  }

  googleLogin() {
    this.auth.loginWithGoogle();
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/march-madness/march-madness.component.ts